module.exports = __webpack_public_path__ + "static/media/playVideo3.94d52c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/playVideo3.png
// module id = 976
// module chunks = 0